import React, { ReactElement, memo, FunctionComponent, useEffect } from 'react'
import BigTeaserSkeleton from '../BigTeaserSkeleton'
import { TestID } from '../../utils/PropTypesDefinitions'
import { logComponentDeprecation } from '../../utils/Deprecation'

const TopStorySkeleton: FunctionComponent<TestID> = ({ testID }): ReactElement => {
    /* istanbul ignore next */
    useEffect(() => {
        logComponentDeprecation('TopStorySkeleton')
    }, [])

    return <BigTeaserSkeleton isTopStory={true} testID={testID} />
}

export default memo(TopStorySkeleton)
